import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center justify-center pt-10 pb-20 overflow-hidden" data-id="element-92">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1546069901-ba9599a7e63c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80")'
    }} data-id="element-93">
        <div className="absolute inset-0 bg-darkGreen/85 backdrop-blur-[2px]" data-id="element-94"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-95">
        <div className="max-w-4xl mx-auto text-center" data-id="element-96">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-97">
            <span className="inline-block py-1 px-3 rounded-full bg-vibrantGreen/20 text-vibrantGreen font-bold text-sm mb-6 border border-vibrantGreen/30 uppercase tracking-wider" data-id="element-98">
              Nuevo Lanzamiento 2024
            </span>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white leading-[1.1] mb-6 font-montserrat tracking-tight" data-id="element-99">
              Las <span className="text-vibrantGreen" data-id="element-100">30 cenas</span> que te
              ayudan a <span className="text-vibrantGreen" data-id="element-101">bajar grasa</span>{' '}
              sin dejar de comer{' '}
              <span className="relative inline-block" data-id="element-102">
                <span className="text-vibrantGreen" data-id="element-103">rico</span>
                <span className="absolute left-0 right-0 -bottom-1 h-1 bg-vibrantGreen/40 rounded-full" data-id="element-104"></span>
              </span>
            </h1>

            <p className="text-lg md:text-xl text-gray-200 mb-10 max-w-2xl mx-auto font-sans leading-relaxed" data-id="element-105">
              Recetas listas en{' '}
              <strong className="text-white font-bold" data-id="element-106">15 minutos</strong>,{' '}
              <strong className="text-white font-bold" data-id="element-107">
                altas en proteína
              </strong>{' '}
              y pensadas para{' '}
              <em className="text-vibrantGreen not-italic font-semibold" data-id="element-108">
                transformar tu cuerpo
              </em>
              .
            </p>
          </motion.div>

          <div className="flex flex-col md:flex-row items-center justify-center gap-10 mb-12" data-id="element-109">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="relative w-full max-w-sm" data-id="element-110">
              {/* Mockup Placeholder - using a styled container since we don't have a real 3D mockup image */}
              <div className="relative aspect-[3/4] bg-gradient-to-br from-darkGreen to-gray-900 rounded-2xl shadow-2xl border border-gray-700 overflow-hidden transform -rotate-2 hover:rotate-0 transition-transform duration-300" data-id="element-111">
                <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1490645935967-10de6ba17061?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80')] bg-cover bg-center opacity-40 mix-blend-overlay" data-id="element-112"></div>
                <div className="absolute inset-0 p-6 flex flex-col justify-between" data-id="element-113">
                  <div className="text-left" data-id="element-114">
                    <span className="text-vibrantGreen font-bold text-xs uppercase tracking-widest" data-id="element-115">
                      Ebook Digital
                    </span>
                    <h3 className="text-white font-black text-2xl mt-2 leading-tight" data-id="element-116">
                      30 CENAS
                      <br data-id="element-117" />
                      PROTEICAS
                    </h3>
                    <p className="text-gray-300 text-sm mt-1" data-id="element-118">EN 15 MINUTOS</p>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-119">
                    <div className="w-8 h-8 rounded-full bg-vibrantGreen flex items-center justify-center" data-id="element-120">
                      <CheckCircle2 className="w-5 h-5 text-darkGreen" data-id="element-121" />
                    </div>
                    <span className="text-white text-sm font-bold" data-id="element-122">
                      +20 Bonos Exclusivos
                    </span>
                  </div>
                </div>
                {/* Glossy reflection effect */}
                <div className="absolute inset-0 bg-gradient-to-tr from-white/0 via-white/10 to-white/0 transform -skew-x-12 translate-x-full group-hover:translate-x-[-100%] transition-transform duration-1000" data-id="element-123"></div>
              </div>

              {/* Shadow under mockup */}
              <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 w-3/4 h-6 bg-black/50 blur-xl rounded-full" data-id="element-124"></div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.6,
            delay: 0.4
          }} className="w-full max-w-md flex flex-col items-center md:items-start" data-id="element-125">
              <ul className="space-y-4 mb-8 text-left w-full" data-id="element-126">
                {['Recetas listas en 15 minutos o menos', 'Ingredientes económicos y fáciles de conseguir', 'Macros calculados para perder grasa', 'No necesitas experiencia cocinando'].map((item, index) => <li key={index} className="flex items-start gap-3 text-white" data-id="element-127">
                    <CheckCircle2 className="w-6 h-6 text-vibrantGreen flex-shrink-0 mt-0.5" data-id="element-128" />
                    <span className="font-medium" data-id="element-129">{item}</span>
                  </li>)}
              </ul>

              <div className="w-full" data-id="element-130">
                <a href="https://recetasexpress.store" target="_blank" rel="noopener noreferrer" className="group relative flex items-center justify-center w-full bg-vibrantGreen hover:bg-[#40a075] text-darkGreen font-black text-lg md:text-xl py-5 px-8 rounded-xl shadow-[0_0_30px_rgba(82,183,136,0.4)] hover:shadow-[0_0_40px_rgba(82,183,136,0.6)] transition-all duration-300 transform hover:-translate-y-1 overflow-hidden" data-id="element-131">
                  <div className="absolute inset-0 bg-white/20 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700 ease-out" data-id="element-132"></div>
                  <span className="relative z-10 flex items-center gap-2" data-id="element-133">
                    QUIERO EL PACK COMPLETO
                    <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-134" />
                  </span>
                </a>
                <p className="text-urgencyRed font-bold text-sm mt-4 text-center animate-pulse flex items-center justify-center gap-2" data-id="element-135">
                  <span data-id="element-136">⚠️</span> Oferta limitada disponible hoy
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}